import { render, staticRenderFns } from "./OpportunityCard.vue?vue&type=template&id=83793b24&scoped=true&"
import script from "./OpportunityCard.vue?vue&type=script&lang=ts&"
export * from "./OpportunityCard.vue?vue&type=script&lang=ts&"
import style0 from "./OpportunityCard.vue?vue&type=style&index=0&id=83793b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83793b24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon,VImg})
